<header>
  <div id="header-overlay" style={{backgroundImage: "url(https://cloud.githubusercontent.com/assets/914595/14740387/201976da-08c1-11e6-8779-2518801361cb.jpg)"}}></div>
  <div id="overlay">
    <div className="logo">
      <a><img src={logo} alt={title || ''} /></a>
      {title}
    </div>
    <div className="socials">
      <div><a href="#/"><i className="fa fa-twitter" aria-hidden="true"></i></a></div>
      <div><a href="https://github.com/graffie"><i className="fa fa-github" aria-hidden="true"></i></a></div>
      <div><a href="#/"><i className="fa fa-instagram" aria-hidden="true"></i></a></div>
      <div><a href="#/"><i className="fa fa-medium" aria-hidden="true"></i></a></div>
    </div>
  </div>
  <span id="more">
    <i className="fa fa-angle-double-down" aria-hidden="true"></i>
  </span>
</header>



/** WEBPACK FOOTER **
 ** ./htmls/side-bar.html
 **/